import { Chip } from "@mui/material";
import VerifiedIcon from "@mui/icons-material/Verified";
import * as React from "react";

/**
 * Solid "Official" badge shown for teams with `isOfficial === true`.
 * Shared between the Teams overview list and the Team detail page so the
 * styling stays in sync.
 */
const OfficialBadge: React.FC = () => (
  <Chip
    icon={<VerifiedIcon />}
    label="Official"
    size="small"
    sx={{
      fontSize: "0.7rem",
      height: 20,
      fontWeight: 700,
      color: "#fff",
      backgroundColor: "success.dark",
      "& .MuiChip-icon": { color: "#fff" },
    }}
  />
);

export default OfficialBadge;
